import script from "./AdvancePaymentPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvancePaymentPrice.vue?vue&type=script&setup=true&lang=js"

import "./AdvancePaymentPrice.vue?vue&type=style&index=0&id=5a636a77&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a636a77"]])

export default __exports__